import { PreSignedFileContainerModel} from '../../../../../../models/aggregates/fm/file';
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config } from '../../shared';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';


@Injectable({providedIn: 'root'})
export class PreSignedFileService extends BaseApiTemplateService<PreSignedFileContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FM_MODULE + 'files';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FM_MODULE + 'files';
    this.httpClient = http;
  }

  getFile(urlKeys: PreSignedFileContainerModel,   visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let url = this.apiUrl + '/file/pre-signed-urls?tenantCode=' + visa.tenantCode;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/pre-signed-urls?tenantCode=' + visa.tenantCode;
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(url, urlKeys, this.getHttpHeader(visa));
  }

}
